import PadImportPage from './padImportPage';

export default PadImportPage;
